<template>
  <basic-container>
    <el-dialog
      :title="title"
      :visible.sync="showDialogForm"
      :modal-append-to-body="false"
      width="80%"
      @closed="handleClose"
    >
      <div>
        <!-- v-if="showDialogForm" -->
        <el-form
          v-if="showDialogForm"
          :disabled="disabled"
          ref="dialogForm"
          :model="dialogForm"
          label-width="120px"
          margin-top="10px"
          margin-right="5px"
          :rules="rules"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="停车场"
                prop="parkingLotId"
                :rules="[{ required: true, message: '请选择停车场', trigger: 'blur' }]"
              >
                <el-select :disabled="edit" v-model="dialogForm.parkingLotId" style="width: 100%">
                  <el-option
                    style="padding-left: 10px"
                    v-for="item in parkingLotList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="规则名称"
                prop="ruleName"
                :rules="[{ required: true, message: '请输入规则名称', trigger: 'blur' }]"
              >
                <el-input @input="input" :disabled="edit" v-model="dialogForm.ruleName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="规则编号"
                prop="ruleCode"
                :rules="[{ required: true, message: '请输入规则编号', trigger: 'blur' }]"
              >
                <el-input @input="input" :disabled="edit" v-model="dialogForm.ruleCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="车型"
                prop="vehicleType"
                :rules="[{ required: true, message: '请选择车型', trigger: 'blur' }]"
              >
                <el-select :disabled="edit" v-model="dialogForm.vehicleType" style="width: 100%">
                  <el-option
                    style="padding-left: 10px"
                    v-for="item in vehicleTypeList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="临停收费方式">
                <el-radio-group
                  :disabled="edit"
                  v-model="dialogForm.dayBillingType"
                  @change="ruleTypeChanged"
                >
                  <el-radio :disabled="edit" label="0" value="0" style="padding-left: 20px"
                    >按24小时收费</el-radio
                  >
                  <el-radio :disabled="edit" label="1" value="1" style="padding-left: 20px"
                    >按白天/晚上收费</el-radio
                  >
                  <!-- <el-radio  v-for="(item, index) in tempcarRuleTypeList" :key="index" :label="item.dictKey" style="padding-left: 20px;">{{
                      item.dictValue
                    }}</el-radio> -->
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24"> </el-col>
          </el-row>
          <div v-if="dialogForm.dayBillingType == 1 && edit != 'true'">
            <el-divider content-position="left"><strong>白天收费规则</strong></el-divider>
            <el-divider content-position="right"><strong>夜晚收费规则</strong></el-divider>
            <el-row class="divider">
              <el-col span="11">
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label-width=""
                      label="白天时间"
                      prop="dayTimeRange"
                      :rules="[{ required: true, message: '请输入白天时间段', trigger: 'change' }]"
                    >
                      <el-time-select
                        style="width: 150px"
                        @change="changeTime"
                        placeholder="起始时间"
                        v-model="startTime"
                        :picker-options="{
                          start: '02:00',
                          step: '00:15',
                          end: '23:30',
                        }"
                      >
                      </el-time-select>
                      至
                      <el-time-select
                        style="width: 150px"
                        @change="changeTime"
                        placeholder="结束时间"
                        v-model="endTime"
                        :picker-options="{
                          start: '02:00',
                          step: '00:15',
                          end: '23:30',
                          minTime: startTime,
                        }"
                      ></el-time-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col span="2"></el-col>
                  <el-col span="8">
                    <el-form-item label-width="120px">
                      <template slot="label">
                        <el-checkbox-group
                          v-model="includeFreeTime"
                          @change="(e) => checkboxChangeValue(e, 'includeFreeTime')"
                        >
                          <el-checkbox label="是否包含免费时长" name="type"></el-checkbox>
                        </el-checkbox-group>
                      </template>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item
                      label-width="120px"
                      label="免费时长"
                      hide-required-asterisk="true"
                      prop="freeTime"
                      :rules="[
                        { required: true, message: '请输入免费时长', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                        { pattern: /^[+]?\d{1,6}$/, message: '格式错误' },
                      ]"
                    >
                      <el-input @input="input" type="number" v-model="dialogForm.freeTime"
                        ><template slot="append">分钟</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="2"></el-col>
                  <el-col span="8">
                    <el-form-item label-width="120px">
                      <template slot="label">
                        <el-checkbox-group
                          v-model="freeTimeLoop"
                          @change="(e) => checkboxChangeValue(e, 'freeRimeLoop')"
                        >
                          <el-checkbox label="免费时长是否循环" name="type"></el-checkbox>
                        </el-checkbox-group>
                      </template>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item
                      label-width="120px"
                      label="日最高收费"
                      prop="freeTime"
                      :rules="[
                        { required: true, message: '请输入最高收费', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input @input="input" type="number" v-model="dialogForm.dayHeightestAmount"
                        ><template slot="append">元</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col span="8" v-for="item in hoursTime" :key="item">
                    <el-form-item
                      label-width="70px"
                      :label="item + '小时'"
                      :prop="getParkingTimeKey(item, 'parkingTime')"
                      :rules="[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input
                        @input="input"
                        type="number"
                        v-model="dialogForm[getParkingTimeKey(item, 'parkingTime')]"
                        ><template slot="append">元</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col span="2" style="height: 100%"> </el-col>
              <div style="height: 100%; border: 1px solid #999" class="divider2"></div>
              <el-col span="11">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label-width="" label="夜晚时间">
                      <el-time-select
                        disabled="true"
                        style="width: 150px"
                        placeholder="起始时间"
                        v-model="endTime"
                        :picker-options="{
                          start: '02:00',
                          step: '00:15',
                          end: '23:30',
                        }"
                      >
                      </el-time-select>
                      至
                      <el-time-select
                        disabled="true"
                        style="width: 150px"
                        placeholder="结束时间"
                        v-model="startTime"
                        :picker-options="{
                          start: '02:00',
                          step: '00:15',
                          end: '23:30',
                          minTime: startTime,
                        }"
                      ></el-time-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col span="2"></el-col>
                  <el-col span="8">
                    <el-checkbox-group
                      v-model="includeFreeTimeNight"
                      @change="(e) => checkboxChangeValue(e, 'includeFreeTimeNight')"
                    >
                      <el-checkbox label="是否包含免费时长"></el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                  <el-col span="12">
                    <el-form-item
                      label-width="120px"
                      label="免费时长"
                      hide-required-asterisk="true"
                      prop="freeTimeNight"
                      :rules="[
                        { required: true, message: '请输入免费时长', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input @input="input" type="number" v-model="dialogForm.freeTimeNight"
                        ><template slot="append">分钟</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="2"></el-col>
                  <el-col span="8">
                    <el-checkbox-group
                      v-model="freeTimeLoopNight"
                      @change="(e) => checkboxChangeValue(e, 'freeTimeLoopNight')"
                    >
                      <el-checkbox label="免费时长是否循环"></el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                  <el-col span="12">
                    <el-form-item
                      label-width="120px"
                      label="夜最高收费"
                      prop="dayHeightestAmountNight"
                      :rules="[
                        { required: true, message: '请输入最高收费', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input
                        @input="input"
                        type="number"
                        v-model="dialogForm.dayHeightestAmountNight"
                        ><template slot="append">元</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col span="8" v-for="item in hoursTime" :key="item">
                    <el-form-item
                      label-width="70px"
                      :label="item + '小时'"
                      :prop="getParkingTimeKey(item, 'parkingTimeNight')"
                      :rules="[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input
                        @input="input"
                        type="number"
                        v-model="dialogForm[getParkingTimeKey(item, 'parkingTimeNight')]"
                        ><template slot="append">元</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <div v-if="dialogForm.dayBillingType == 1 && edit == 'true' && dayBillingTypeNight != 2">
            <el-divider content-position="left"><strong>白天收费规则</strong></el-divider>
            <el-row class="divider">
              <el-col span="24">
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label-width=""
                      label="白天时间"
                      prop="dayTimeRange"
                      :rules="[{ required: true, message: '请输入白天时间段', trigger: 'change' }]"
                    >
                      <el-time-select
                        style="width: 150px"
                        @change="changeTime"
                        placeholder="起始时间"
                        v-model="startTime"
                        :picker-options="{
                          start: '02:00',
                          step: '00:15',
                          end: '23:30',
                        }"
                      >
                      </el-time-select>
                      至
                      <el-time-select
                        style="width: 150px"
                        @change="changeTime"
                        placeholder="结束时间"
                        v-model="endTime"
                        :picker-options="{
                          start: '02:00',
                          step: '00:15',
                          end: '23:30',
                          minTime: startTime,
                        }"
                      ></el-time-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col span="2"></el-col>
                  <el-col span="8">
                    <el-form-item label-width="120px">
                      <template slot="label">
                        <el-checkbox-group
                          v-model="includeFreeTime"
                          @change="(e) => checkboxChangeValue(e, 'includeFreeTime')"
                        >
                          <el-checkbox label="是否包含免费时长" name="type"></el-checkbox>
                        </el-checkbox-group>
                      </template>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item
                      label-width="120px"
                      label="免费时长"
                      hide-required-asterisk="true"
                      prop="freeTime"
                      :rules="[
                        { required: true, message: '请输入免费时长', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                        { pattern: /^[+]?\d{1,6}$/, message: '格式错误' },
                      ]"
                    >
                      <el-input @input="input" type="number" v-model="dialogForm.freeTime"
                        ><template slot="append">分钟</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="2"></el-col>
                  <el-col span="8">
                    <el-form-item label-width="120px">
                      <template slot="label">
                        <el-checkbox-group
                          v-model="freeTimeLoop"
                          @change="(e) => checkboxChangeValue(e, 'freeRimeLoop')"
                        >
                          <el-checkbox label="免费时长是否循环" name="type"></el-checkbox>
                        </el-checkbox-group>
                      </template>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item
                      label-width="120px"
                      label="日最高收费"
                      prop="freeTime"
                      :rules="[
                        { required: true, message: '请输入最高收费', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input @input="input" type="number" v-model="dialogForm.dayHeightestAmount"
                        ><template slot="append">元</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col span="6" v-for="item in hoursTime" :key="item">
                    <el-form-item
                      label-width="70px"
                      :label="item + '小时'"
                      :prop="getParkingTimeKey(item, 'parkingTime')"
                      :rules="[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input
                        @input="input"
                        type="number"
                        v-model="dialogForm[getParkingTimeKey(item, 'parkingTime')]"
                        ><template slot="append">元</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <div v-if="dayBillingTypeNight == 2 && edit == 'true' && dialogForm.dayBillingType == 1">
            <el-divider content-position="right"><strong>黑夜收费规则</strong></el-divider>
            <el-row>
              <el-col span="24">
                <el-row>
                  <el-col span="2"></el-col>
                  <el-col span="8">
                    <el-checkbox-group
                      v-model="includeFreeTime"
                      @change="(e) => checkboxChangeValue(e, 'includeFreeTime')"
                    >
                      <el-checkbox label="是否包含免费时长"></el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                  <el-col span="12">
                    <el-form-item
                      label-width="120px"
                      label="免费时长"
                      hide-required-asterisk="true"
                      prop="freeTime"
                      :rules="[
                        { required: true, message: '请输入免费时长', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input @input="input" type="number" v-model="dialogForm.freeTime"
                        ><template slot="append">分钟</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="2"></el-col>
                  <el-col span="8">
                    <el-checkbox-group
                      v-model="freeTimeLoop"
                      @change="(e) => checkboxChangeValue(e, 'freeTimeLoop')"
                    >
                      <el-checkbox label="免费时长是否循环"></el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                  <el-col span="12">
                    <el-form-item
                      label-width="120px"
                      label="夜最高收费"
                      prop="dayHeightestAmount"
                      :rules="[
                        { required: true, message: '请输入最高收费', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input @input="input" type="number" v-model="dialogForm.dayHeightestAmount"
                        ><template slot="append">元</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="8" v-for="item in hoursTime" :key="item">
                    <el-form-item
                      label-width="70px"
                      :label="item + '小时'"
                      :prop="getParkingTimeKey(item, 'parkingTime')"
                      :rules="[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                      ]"
                    >
                      <el-input
                        @input="input"
                        type="number"
                        v-model="dialogForm[getParkingTimeKey(item, 'parkingTime')]"
                        ><template slot="append">元</template></el-input
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
<!--        24小时收费模式 -->
          <div v-if="dialogForm.dayBillingType == 0">
            <el-divider content-position="left"><strong>时长收费设置</strong></el-divider>
            <el-row :gutter="10">
              <el-col :span="5">
                <el-form-item label-width="130px" label="包含免费时长"
                              :rules="[{ required: true, message: '请选择是否包含免费时长', trigger: 'blur' },]">
                  <el-radio v-model="dialogForm.includeFreeTime" label="1">是</el-radio>
                  <el-radio v-model="dialogForm.includeFreeTime" label="0">否</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item
                  label-width=""
                  label="免费时长"
                  prop="freeTime"
                  :rules="[
                    { required: true, message: '请输入免费时长', trigger: 'blur' },
                    { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                    //{ pattern: /^[+]?\d{1,6}$/, message: '格式错误' },

                  ]"
                >
                  <el-input @input="input" maxlength="5" type="number" v-model="dialogForm.freeTime"
                    ><template slot="append">分钟</template></el-input
                  >
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label-width="130px" label="免费时长是否循环">
                  <el-radio v-model="dialogForm.freeTimeLoop" label="1">是</el-radio>
                  <el-radio v-model="dialogForm.freeTimeLoop" label="0">否</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item
                  label-width="130px"
                  label="24小时最高收费"
                  prop="dayHeightestAmount"
                  :rules="[
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                  ]"
                >
                  <el-input @input="input" v-model="dialogForm.dayHeightestAmount"
                    ><template slot="append">元</template></el-input
                  >
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item
                  label-width="130px"
                  label="总金额不超过"
                  prop="totalAmountLimit"
                  :rules="[
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                    { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
                  ]"
                >
                  <el-input @input="input" type="number" v-model="dialogForm.totalAmountLimit"
                  ><template slot="append">元</template></el-input
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider content-position="left"><strong>收费方式</strong></el-divider>
            <el-row>
              <el-col span="6" v-for="item in hoursTime" :key="item">
                <el-form-item
                  label-width="70px"
                  :label="item + '小时'"
                  :prop="getParkingTimeKey(item, 'parkingTime')"
                  :rules="[
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    { max: 99999999, message: '请输入有效数字', trigger: 'change' },
                    { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
                  ]"
                >
                  <el-input
                    @input="input"
                    type="number"
                    v-model="dialogForm[getParkingTimeKey(item, 'parkingTime')]"
                    ><template slot="append">元</template></el-input
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div style="text-align: center; margin-top: 20px" v-if="!disabled">
            <div>
              <el-form-item label-width="0px">
                <el-button type="primary" @click="submit">提 交</el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { getDetail } from '@/api/v4ward/park/vehicle/parkvehicletyperule';
import { getParkingLotList } from '@/api/v4ward/park/lot/parkinglot';
import { getDictionaryWithIntKey } from '@/api/common';
import { mapGetters } from 'vuex';

export default {
  props: ['disabled', 'edit'],
  data() {
    return {
      hoursTime: 24,
      value: '',
      time: '',
      dayBillingTypeNight: null,
      startTime: '',
      endTime: '',
      aaaa: [],
      bbb: [],
      showDialogForm: false,
      title: '',
      parkingLotList: [],
      vehicleTypeList: [],
      tempcarRuleTypeList: [],
      includeFreeTime: '0',
      freeTimeLoop: '0',
      includeFreeTimeNight: false,
      freeTimeLoopNight: false,
      dialogForm: {
        includeFreeTime: 0,
        freeTimeLoop: 0,
        freeTimeLoopNight: '0',
        includeFreeTimeNight: '0',
        dayBillingType: '0',
        includeFreeTime: '0',
        freeTimeLoop: '0',
        dayTimeRange: '',
        totalAmountLimit: '10000',
        // ruleInfo: {
        //   tempcarRuleType: 1,
        // },
        // ruleData: {
        //   ruleDay: {},
        //   ruleNight: {},
        //   rule24h: {},
        // },
      },
    };
  },
  created() {},
  mounted() {
    this.initAllSelectionList();
  },
  methods: {
    submit() {
      if (!(this.startTime && this.endTime)) {
        this.dialogForm.dayTimeRange = '';
      }
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          if (this.dialogForm.dayBillingType == 1) {
            for (let i = this.hours; i < 25; i++) {
              this.dialogForm[this.getParkingTimeKey(i, 'parkingTime')] = this.dialogForm[
                this.getParkingTimeKey(this.hours, 'parkingTime')
              ];
            }
            for (let i = 25 - this.hours; i < 25; i++) {
              this.dialogForm[this.getParkingTimeKey(i, 'parkingTimeNight')] = this.dialogForm[
                this.getParkingTimeKey(this.hours, 'parkingTimeNight')
              ];
            }
          }
          if (this.edit == 'true') {
            if (this.dayBillingTypeNight == 2) {
              this.dialogForm.dayBillingType = 2;
            }
            this.$emit('update', this.dialogForm);
          } else {
            this.$emit('submit', this.dialogForm);
          }

          console.log(this.dialogForm);
          this.showDialogForm = false;
          this.reset();
        } else {
          return false;
        }
      });
    },
    reset() {
      this.startTime = '';
      this.endTime = '';
      this.includeFreeTime = '0';
      this.freeTimeLoop = '0';
      this.includeFreeTimeNight = false;
      this.freeTimeLoopNight = false;
      let obj = {};
      obj.includeFreeTime = 0;
      obj.freeTimeLoop = 0;
      obj.freeTimeLoopNight = '0';
      obj.includeFreeTimeNight = '0';
      obj.dayBillingType = '0';
      obj.includeFreeTime = '0';
      obj.freeTimeLoop = '0';
      obj.dayTimeRange = '';
      this.dialogForm = obj;
    },
    // 循环小时输入框时绑定参数字段
    getParkingTimeKey(item, name) {
      return item < 10 ? name + '0' + item : name + item;
    },
    // 关闭弹窗时事件
    // handleClose(){
    //   if(this.dayBillingTypeNight==2){
    //     this.dialogForm.dayBillingType=2;
    //   }
    // },
    changeTime(e) {
      if (
        this.endTime == '' ||
        this.endTime == null ||
        this.startTime == null ||
        this.startTime == ''
      ) {
        return;
      }
      this.dialogForm.dayTimeRange = this.startTime + '-' + this.endTime;
      if (this.dialogForm.dayBillingType == 1) {
        console.log(this.dialogForm.dayTimeRange);
      }
      // this.hours = this.dayjs('2020-12-25'+this.endTime+':00').diff(this.dayjs('2020-12-25'+this.startTime+':00'),'hour')+1;
    },
    checkboxChangeValue(e, targetValue) {
      if (e) {
        this.dialogForm[targetValue] = '1';
        console.log(this.dialogForm.freeTimeLoop);
      } else {
        this.dialogForm[targetValue] = '0';
      }
    },
    click(...e) {
      console.log(123);
      console.log(e);
    },
    input(e) {
      this.$forceUpdate();
      // for(let i =item ; i<=25;i++){
      //   this.dialogForm[this.getParkingTimeKey(i , 'parkingTime')] = e;
      // }
    },
    ruleTypeChanged(value) {
      console.log(this.dialogForm.dayBillingType);
      console.log('============' + value);
    },
    initAllSelectionList() {
      getParkingLotList().then((res) => {
        this.parkingLotList = res.data;
      });
      getDictionaryWithIntKey('vehicle_type').then((data) => {
        this.vehicleTypeList = data.data;
      });
      getDictionaryWithIntKey('tempcar_rule_type').then((data) => {
        this.tempcarRuleTypeList = data.data;
      });
    },

    openDialogForm(title, row) {
      this.title = title;
      console.log(row);
      if (row) {
        for (let key in row) {
          this.dialogForm[key] = row[key];
        }
        // this.dialogForm = row;
        // 给白天晚上模式的checkedbox赋值
        this.dialogForm.includeFreeTime == 1
          ? (this.includeFreeTime = true)
          : (this.includeFreeTime = false);
        this.dialogForm.freeTimeLoop == 1
          ? (this.freeTimeLoop = true)
          : (this.freeTimeLoop = false);

        // 24小时收费模式赋值
        if (this.dialogForm.dayBillingType == 0 || this.dialogForm.dayBillingType == 1) {
          this.dialogForm.includeFreeTime = String(this.dialogForm.includeFreeTime);
          this.dialogForm.freeTimeLoop = String(this.dialogForm.includeFreeTime);
        }

        if (this.dialogForm.dayBillingType == 2) {
          this.dialogForm.dayBillingType = '1';
          this.dayBillingTypeNight = 2;
        } else {
          this.dialogForm.dayBillingType = String(this.dialogForm.dayBillingType);
          this.dayBillingTypeNight = String(this.dialogForm.dayBillingType);
        }

        // this.dialogForm.includeFreeTime = String(this.dialogForm.includeFreeTime);
        // this.dialogForm.freeTimeLoop = String(this.dialogForm.freeTimeLoop);

        // 24小时最高收费赋值
        this.dialogForm.dayHeightestAmount = String(this.dialogForm.dayHeightestAmount);
        //单次收费限额
        this.dialogForm.totalAmountLimit = String(this.dialogForm.totalAmountLimit);

        this.dialogForm.freeTime = String(this.dialogForm.freeTime);
        // 白天时间段赋值
        if (this.dialogForm.dayBillingType == 1) {
          this.startTime = this.dialogForm.dayTimeRange.slice(0, 5);
          this.endTime = this.dialogForm.dayTimeRange.slice(6);
        }
        //  将收费规则转为string类型通过表单验证

        for (let i = 1; i <= 24; i++) {
          if (typeof this.dialogForm[this.getParkingTimeKey(i, 'parkingTime')] != 'string') {
            this.dialogForm[this.getParkingTimeKey(i, 'parkingTime')] = String(
              this.dialogForm[this.getParkingTimeKey(i, 'parkingTime')]
            );
          }
        }
      }

      this.showDialogForm = true;
    },
  },
};
</script>

<style scoped>
.divider {
  position: relative;
}
.divider2 {
  position: absolute;
  left: 50%;
}
.el-dialog__body {
  padding-right: 60px;
}
</style>
